export default {
    
    text_0: "Používatelia",
    text_1: "Moji používatelia",
    text_2: "Vytvor si ďalšie prístupy",
    text_3: "Tu si môžeš ďalších vytvoriť používateľov, ktorí majú prístup k tvojmu účtu. Skvelá voľba, ak máš zamestnancov.",
    text_4: "Vytvoriť prístup",
    text_5: "Tvoje prístupy",
    text_6: "Meno",
    text_7: "Priezvisko",
    text_8: "E-mail",
    text_9: "Heslo",
    text_10: "Uložiť",
    text_11: "Vytvoriť",
    text_12: "Ukončiť",
    text_13: "E-mail",
    text_14: "Meno a priezvisko",
    text_15: "Akcie",
    text_16: "Upraviť",
    text_17: "Vymazať",

    text_edit_success: "Prístup úspešne upravený.",
    text_create_success: "Prístup úspešne vytvorený.",
    error_email_exists: "Email už existuje.",
    text_remove_success: "Prístup úspešne vymazaný."
}